<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="客户信息：" prop="keywords">
            <el-input v-model="query.keywords" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="客户身份：" prop="CLevel">
            <el-select v-model="query.CLevel" placeholder="请选择客户身份" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="折扣组：">
            <el-select v-model="query.profitRatioId" placeholder="请选择折扣组" clearable size="small">
              <el-option :label="item.title" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用友编码：" prop="code">
            <el-input v-model="query.code" placeholder="请输入用友编码" size="small" />
          </el-form-item>
          <el-form-item label="通商云ID：" prop="bizUserId">
            <el-input v-model="query.bizUserId" placeholder="请输入通商云ID" size="small" />
          </el-form-item>
          <el-form-item label="带教老师：" prop="techInfoIdForBig">
            <el-select v-model="query.techInfoIdForBig" placeholder="请选择带教老师" clearable size="small" filterable>
              <el-option v-for="(item,index) in options.teacherList" :key="index" :label="`${item.realName}（${item.mobile}）${item.levelName ? '(' + item.levelName + ')' : ''}`" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="老师身份：">
            <el-select v-model="query.techInfoLevelIdForBig" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.technicalServiceLevel" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域：">
            <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-upload style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList" v-hasPermi="['client:clientList:import']">
            <el-button size="mini" type="primary" plain>导入大客户</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleDownTemplate" plain>下载模板</el-button>
          <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
          <el-button type="primary" size="mini" @click="handleRemove(selectItems)">批量移除大客户</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加大客户</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column type="selection" width="50" fixed />
        <el-table-column :width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="index<2" :sortable="item.isSortable" :align="item.align">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)" v-if="item.prop === 'customer'">
              <el-link type="primary">{{row.name}}({{row.levelName}})</el-link><br />
              <el-link type="primary">{{row.pho}}</el-link>
            </div>
            <span v-else-if="item.prop === 'profitRatio.title'">{{row.profitRatio && row.profitRatio.title}}</span>
            <span v-else-if="item.prop === 'customerUserPO.bizUserId'">{{row.customerUserPO && row.customerUserPO.bizUserId}}</span>
            <span v-else-if="item.prop === 'customerSub.changeTechReasonForBig'">{{row.customerSub && row.customerSub.changeTechReasonForBig}}</span>
            <div v-else-if="item.prop === 'customerSub'">
              <span>{{row.customerSub.techInfoRealNameForBig}}{{row.customerSub.techInfoLevelName ?'(' + row.customerSub.techInfoLevelName + ')' : ''}}</span><br />
              <span>{{row.customerSub.techInfoMobileForBig}}</span>
            </div>
            <block v-else-if="item.prop === 'customerCertificates'">
              <div @click="handleShow(row)" v-if="row.customerCertificates">
                <el-link type="primary">认证类型：{{row.customerCertificates.certificatesType==1?'企业认证':'个人认证'}}</el-link><br />
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==1">企业名称：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==2">姓名：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
              </div>
            </block>
            <block v-else-if="item.prop === 'addr'">
              <span>{{row.addrProvinceName}}{{row.addrCityName}}{{row.addrAreaName}}</span>
            </block>
            <span v-else-if="item.prop === 'profitRatio.operatedTime'">{{row.profitRatio && row.profitRatio.operatedTime}}</span>
            <span v-else-if="item.prop === 'customerSub.operatedByNameForBig'">{{row.customerSub && row.customerSub.operatedByNameForBig}}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,2)">修改带教老师</el-button>
            <el-button type="text" @click="handleRemove(row)">移除大客户</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <!-- 企业认证 -->
    <client-show ref="clientShow" @created="doQueryList({})"></client-show>
    <big-client-add ref="bigClientAdd" @created="doQueryList({})" :popType="popType" />
  </div>
</template>

<script>
import bigClientAdd from './add'
import clientListApi from '@/api/client/clientList'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import sysAddrApi from '@/api/sys/sysAddr'
import Pagination from '@/components/Pagination'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import customerSubApi from '@/api/client/customerSub'
import clientShow from '../clientList/show.vue'
import technicianInfoApi from '@/api/technical/technicianInfo'
export default {
  components: {
    Pagination,
    bigClientAdd,
    clientShow
  },
  data() {
    return {
      // level 6:研修班 7:体验班 8:普通用户
      list: [],
      total: 0,
      popType: null,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true
        // multiple: true
      },
      selectItems: [],
      standingList: [],
      discountList: [],
      addressList: [],
      businessList: [],
      dateTime: null,
      allTemplate: [
        { label: '客户信息', prop: 'customer', width: '160px', align: 'center' },
        { label: '折扣组', prop: 'profitRatio.title', width: '120px', align: 'center' },
        { label: '用友编码', prop: 'code', width: '130px', align: 'center' },
        { label: '子账号数量', prop: 'subCount', width: '100px', align: 'center' },
        { label: '认证信息', prop: 'customerCertificates', width: '160px' },
        { label: '通商云ID', prop: 'customerUserPO.bizUserId', align: 'center' },
        { label: '所属区域', prop: 'addr', width: '160px', align: 'center' },
        { label: '大客户带教老师', prop: 'customerSub', width: '160px', align: 'center' },
        { label: '操作时间', prop: 'profitRatio.operatedTime', isSortable: true, width: '160px', align: 'center' },
        { label: '操作人', prop: 'customerSub.operatedByNameForBig', align: 'center' },
        { label: '修改原因', prop: 'customerSub.changeTechReasonForBig', align: 'center' },
      ],
      dynamicHeaders: [],
      options: { technicalServiceLevel: [], teacherList: [] }
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getStandingList()
    this.getDiscountList()
    this.getAddressList()
    this.dynamicHeaders = this.allTemplate
    technicalServiceLevelApi.findOptions().then(({ data }) => {
      this.options.technicalServiceLevel = data
    })
    this.getTeacherList()
  },
  methods: {
    teacherFilter(val) {
      this.getTeacherList(val)
    },
    getTeacherList(val) {
      let query = {
        pageSize: 1000,
        status: 10,
        levelIsBigCustomer: true
      }
      technicianInfoApi.fetchList(query).then(({ data }) => {
        this.options.teacherList = data.list
      })
    },
    /**
    * 移除大客户（支持单个和批量）
    */
    handleRemove(row) {
      let ids = []
      let message = ''

      if (Array.isArray(row)) {
        // 批量移除
        if (row.length === 0) {
          this.$message.warning('请选择要移除的大客户')
          return
        }
        ids = row.map(item => item.id)
        message = '确定要批量移除选中的大客户吗？'
      } else {
        // 单个移除
        ids = [row.id]
        message = '确定要移除该大客户吗？'
      }

      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        customerSubApi.setNotBig(ids).then(res => {
          if (res.code === '0') {
            this.$message.success(res.msg || '移除成功')
            this.doQueryList({})
            if (Array.isArray(row)) {
              this.selectItems = [] // 清空选中项
            }
          } else {
            this.$message.error(res.msg || '移除失败')
          }
        }).catch(error => {
          this.$message.error('移除失败：' + error.message)
        })
      }).catch(() => {
        // 用户取消操作
      })
    },
    handleFilter() {
      this.query = { pageNo: 1, pageSize: 10 }
      this.dateTime = []
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      if (this.query.addrid) {
        query.addrProvinceCode = this.query.addrid[0]
        query.addrCityCode = this.query.addrid[1]
        query.addrAreaCode = this.query.addrid[2]
      }
      this.listLoading = true
      return clientListApi.fetchListBig(query)
        .then(({ data }) => {
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 修改学习权限
    changeSwitch(row) {
      console.log('row: ', row);
      let params = {
        canStudy: row.customer.canStudy,
        ywInternTime: row.customer.ywInternTime,
        isIntern: row.customer.isIntern,
        customerId: row.customer.id
      }
      // return
      clientListApi.updateStudy(params)
      this.$message.success('状态修改成功')
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({ type: 3 }).then(({ data }) => {
        this.standingList = data
      })
    },
    // 获取折扣组列表
    getDiscountList() {
      sysProfitRatioApi.fetchList({ isEnable: 1 }).then(({ data }) => {
        this.discountList = data
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.popType = 0
      this.$refs.bigClientAdd.handleCreate()
    },
    handleUpdate(row, type) {
      this.popType = type
      this.$refs.bigClientAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=110&id=" + row.id);
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.clientShow.handleShow(row.customerCertificates)
    },
    handleDownload() {
      this.$router.push("/export/list?code=EEForCustomerBig")
    },
    handleDownTemplate() {
      customerSubApi.importExcelCustomertemplate()
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      customerSubApi.importExcelCustomerBig(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>
<style>
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
